/*
 * @Author: chenmengnan
 * @Date: 2024-12-17 11:22:15
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-12-17 18:01:04
 * @Description: 用户审核表格配置
 * @FilePath: \web\src\components\DataManagement\userExamine\tableConfig.js
 */
const tableConfigPending = [
  {
    title: '序号',
    slots: { customRender: 'serial' },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '用户名',
    dataIndex: 'username',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '联系方式',
    dataIndex: 'phone',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '邮箱',
    dataIndex: 'email',
    ellipsis: true,
    align: 'center',
  },

  {
    title: '姓名',
    dataIndex: 'name',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '用户单位',
    dataIndex: 'orgName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '信息提交时间',
    dataIndex: 'createTime',
    ellipsis: true,
    align: 'center',
  },

  {
    title: '操作',
    key: 'action',
    slots: { customRender: 'action' },
    align: 'center',
  },
];
const tableConfigApproved = [
  {
    title: '序号',
    slots: { customRender: 'serial' },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '用户名',
    dataIndex: 'username',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '联系方式',
    dataIndex: 'phone',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '邮箱',
    dataIndex: 'email',
    ellipsis: true,
    align: 'center',
  },

  {
    title: '姓名',
    dataIndex: 'name',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '用户单位',
    dataIndex: 'orgName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '信息提交时间',
    dataIndex: 'createTime',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '审核时间',
    dataIndex: 'checkTime',
    ellipsis: true,
    align: 'center',
  },
];
const tableConfigRefuse = [
  {
    title: '序号',
    slots: { customRender: 'serial' },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '用户名',
    dataIndex: 'username',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '联系方式',
    dataIndex: 'phone',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '邮箱',
    dataIndex: 'email',
    ellipsis: true,
    align: 'center',
  },

  {
    title: '姓名',
    dataIndex: 'name',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '用户单位',
    dataIndex: 'orgName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '信息提交时间',
    dataIndex: 'createTime',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '审核时间',
    dataIndex: 'checkTime',
    ellipsis: true,
    align: 'center',
  },
];
export { tableConfigPending, tableConfigApproved, tableConfigRefuse };
